import Radar from 'radar-sdk-js';
import React, { useState } from 'react';
import InputField from './Input-Field/input-field';
import { Paper, Typography } from '@mui/material';

const CTAutocomplete = ({
  disabled,
  fnHandleSelectedLocation,
  margin,
}) => {
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  const handleAddressChange = (event) => {
    const input = event.target.value;
    setQuery(input);
    if (input.length >= 3) {
      Radar.autocomplete({
        query: input,
        limit: 10,
      }).then(resp => {
        setSuggestions(resp.addresses);
      }).catch(error => {
        console.log('Error fetching suggestions.');
      });
    } else {
      setSuggestions([]);
    }
  }

  const handleSuggestionSelect = (place) => {
    setQuery(place.formattedAddress);
    fnHandleSelectedLocation(place);
    setSuggestions([]);
  }

  return (
    <>
      <InputField
        type="text"
        label="Enter Address"
        placeholder={'Enter Company Address'}
        value={query}
        variant={'outlined'}
        fullWidth={true}
        disabled={disabled}
        onChange={handleAddressChange}
        margin={margin ? margin : 'normal'}
      />
      {suggestions.length > 0 && (     
        <Paper style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc'}}>
          {suggestions.map((suggestion, index) => (
            <div
              key={index}
              onClick={() => handleSuggestionSelect(suggestion)}
              style={{ padding: '10px', cursor: 'pointer' }}
            >
              <Typography variant='body1' fontWeight={600}>{suggestion.formattedAddress}</Typography>
            </div>
          ))}
        </Paper>
      )}
    </>
  );
};

export default CTAutocomplete;